import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SPONSORSHIP_QUERY_KEYS } from "@/features/sponsorship/constants/queryKeys";
import { sponsorshipService } from "@/features/sponsorship/services/sponsorship.service";
import type { SponsorshipListResponse } from "@/features/sponsorship/types/sponsorship.type";

export const useRecommendations = () => {
  const { data, isLoading, isError } = useQuery<SponsorshipListResponse>({
    queryKey: SPONSORSHIP_QUERY_KEYS.recommendations(),
    queryFn: () => sponsorshipService.getSponsorshipRequests(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    placeholderData: keepPreviousData,
  });

  const recommendations = data?.sponsorship_requests ?? [];

  return {
    recommendations,
    isLoading,
    isError,
  };
};
